import React from "react";

import { tw } from "~/utils";

interface AvailabilityTimeProps {
  time: string;
  selected: boolean;
  onClick?: () => void;
  isButton?: boolean;
}

const AvailabilityTime: React.FC<AvailabilityTimeProps> = ({
  time,
  selected,
  onClick,
  isButton,
}) => {
  const classAvailableText =
    "text-brown-650 cursor-pointer hover:bg-green-250 bg-green-250/20 overflow-hidden rounded-[51px] w-27 px-4 py-2";
  const classes = tw(
    classAvailableText,
    selected && "bg-black text-green-250 hover:bg-black/40",
  );

  return isButton ? (
    <button className={classes} onClick={onClick}>
      {time}
    </button>
  ) : (
    <div className="text-brown-650 bg-green-250/20 w-27 overflow-hidden rounded-[51px] px-4 py-2">
      {time}
    </div>
  );
};

export default AvailabilityTime;
